import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { User } from 'src/app/models/auth/user';
import { MsalService } from '@azure/msal-angular';
@Injectable({ providedIn: null })
export class AuthService {

    private userSubject!: BehaviorSubject<User>;
    private roleUpdate$ = new Subject();
    public user!: Observable<User>;
    public userClaim: any = {};
    private userSettingInterval: any;
    public getRoleUpdate() {
        return this.roleUpdate$;
    }
    emitRoleUpdate() {
        this.roleUpdate$.next(true);
    }
    constructor(
        private router: Router,
        private http: HttpClient,
        private msalService: MsalService
    ) {
       
    }
    setUserData():Promise<boolean> {
        return new Promise((resolve)=>{
        if (this.userSettingInterval)
            clearInterval(this.userSettingInterval);
        this.userSettingInterval = setInterval(() => {
            for (let key in sessionStorage) {
                let item = sessionStorage.getItem(key);
                if (item && this.isJSON(item)) {
                    let jsonSerializedTokenKey = JSON.parse(item);
                    if (jsonSerializedTokenKey.credentialType == "IdToken" || jsonSerializedTokenKey.credentialType == "AccessToken") {
                        let base64Url = jsonSerializedTokenKey.secret.split('.')[1];
                        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                        let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
                            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                        }).join(''));
                        this.userClaim = JSON.parse(jsonPayload);
                        clearInterval(this.userSettingInterval);
                        setTimeout(()=>{this.emitRoleUpdate();
                             resolve(true);});
                       
                    }
                }
            }
            this.userSubject = new BehaviorSubject<any>(this.userClaim);
            this.user = this.userSubject.asObservable();     
        }, 100);
    });
    }
    public get userValue(): User {
            return this.userSubject?.value;
    }
    isJSON(text: any) {
        if (typeof text !== "string") {
            return false;
        }
        try {
            let json = JSON.parse(text);
            return true;
        }
        catch (error) {
            return false;
        }
    }

    getToken(): string {
        for (let key in sessionStorage) {
            let item = sessionStorage.getItem(key);

            if (item && this.isJSON(item)) {
                const jsonSerializedTokenKey = JSON.parse(item);
                if (jsonSerializedTokenKey.credentialType == "AccessToken") {
                    return jsonSerializedTokenKey['secret'];
                }
            }
        }
        return "";
    }
}
